import moment from "moment";
import { isUndefined } from "lodash";

export const DATE_FORMAT_MM = "MM-DD-YYYY";
export const SEVER_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
export const DATE_TIME_FORMAT_WITHOUT_SECONDS_24HRS = "MM-DD-YYYY HH:mm";

export const disablePastDates = (current: any) => {
  const customDate = moment().format(DATE_FORMAT_MM);
  return current && current < moment(customDate, DATE_FORMAT_MM);
};

export const disableFutureDates = (current: any) => {
  return current && current > Date.now();
};

export const getErrorMessageString = (e: any) => {
  return e?.response?.status === 401 &&
    isUndefined(e?.response?.data?.errorMessage)
    ? e.message
    : e?.response?.data?.errorMessage;
};

